
export default function HyphenationCallback(word){
    
    return [word];
}